import { useMemo } from 'react'

import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import type { SocialMediaType } from '@/modules/statistics/social/types.ts'
import { handleError } from '@/utils/error'

import { getSocialAccountsByCreatorId } from '../data/service'

export const useSocialAccounts = (socialMediaType: SocialMediaType) => {
  const creatorId = useUnit($creatorId)
  const { data, isFetching, refetch } = useQuery(
    ['social', creatorId, socialMediaType],
    () => getSocialAccountsByCreatorId(creatorId!, socialMediaType),
    {
      enabled: !!creatorId,
      onError: (error) =>
        handleError(error, 'Failed to get social accounts', refetch),
    },
  )

  return useMemo(
    () => ({
      data,
      isFetching,
    }),
    [data, isFetching],
  )
}
